/**
 * Páginas de /dashboard/company/* que NO salen del árbol system_option (no son
 * configurables desde "Opciones del sistema") y están disponibles para cualquier
 * usuario del admin, p.ej. "Mi perfil" (fija al pie del menú lateral).
 *
 * permissionGuard las deja pasar sin consultar el árbol de permisos y
 * PageTitleService toma de acá el nombre de la pestaña.
 */
export const STATIC_COMPANY_PAGES: Record<string, string> = {
  'mi-perfil': 'Mi perfil',
};

export const MY_PROFILE_URL = '/dashboard/company/mi-perfil';
